import { useState } from "react";
import { addExpense } from "../../../services/expenseApi";
import { useNavigate } from "react-router-dom";
import "./ExpenseList.css";

export default function AddExpense() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title:  "",
    amount: "",
    type:   "expense",
    date:   new Date().toISOString().split("T")[0],
  });

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.amount) return alert("Please fill all fields");
    try {
      setLoading(true);
      await addExpense(form);
      navigate("/school-admin/expense");
    } catch { alert("Failed to save"); }
    finally { setLoading(false); }
  };

  const isIncome = form.type === "income";

  return (
    <div className="fin-page">

      {/* ══ HERO ══ */}
      <div className="fin-hero">
        <div className="fin-hero-left">
          <div className="fin-hero-icon">{isIncome ? "📈" : "📉"}</div>
          <div>
            <h2 className="fin-hero-title">Add {isIncome ? "Income" : "Expense"} Entry</h2>
            <p className="fin-hero-sub">Record a new financial transaction</p>
          </div>
        </div>
        <div className="fin-hero-right">
          <a href="/school-admin/expense" className="fin-btn-add">← Back</a>
        </div>
      </div>

      {/* ══ FORM ══ */}
      <form onSubmit={handleSubmit}>
        <div style={{
          background:"#fff", borderRadius:"16px",
          border:"1.5px solid #e5e7eb",
          boxShadow:"0 4px 24px rgba(0,0,0,.07)",
          padding:"32px", maxWidth:"600px",
        }}>

          <p style={{
            fontSize:"11px", fontWeight:800, color:"#94a3b8",
            textTransform:"uppercase", letterSpacing:".06em",
            margin:"0 0 24px", paddingBottom:"14px",
            borderBottom:"1.5px solid #f1f5f9",
          }}>
            Transaction Details
          </p>

          {/* TYPE TOGGLE */}
          <div style={{ marginBottom:"22px" }}>
            <p style={{ fontSize:"12px", fontWeight:800, color:"#374151", textTransform:"uppercase", letterSpacing:".05em", marginBottom:"10px" }}>
              Type
            </p>
            <div style={{ display:"flex", gap:"12px" }}>
              {["expense","income"].map(t => (
                <button
                  key={t} type="button"
                  onClick={() => set("type", t)}
                  style={{
                    flex:1, padding:"12px",
                    borderRadius:"10px", border:"2px solid",
                    fontWeight:800, fontSize:"14px",
                    cursor:"pointer", transition:".15s",
                    borderColor: form.type === t
                      ? (t === "income" ? "#22c55e" : "#ef4444")
                      : "#e2e8f0",
                    background: form.type === t
                      ? (t === "income" ? "#dcfce7" : "#fee2e2")
                      : "#fafafa",
                    color: form.type === t
                      ? (t === "income" ? "#166534" : "#991b1b")
                      : "#94a3b8",
                  }}
                >
                  {t === "income" ? "📈 Income" : "📉 Expense"}
                </button>
              ))}
            </div>
          </div>

          {/* TITLE */}
          <div style={{ marginBottom:"18px" }}>
            <label style={{ display:"block", fontSize:"12px", fontWeight:800, color:"#374151", textTransform:"uppercase", letterSpacing:".05em", marginBottom:"7px" }}>
              Title
            </label>
            <input
              required
              placeholder={isIncome ? "e.g. Fees Collection, Donation" : "e.g. Electricity Bill, Stationary"}
              value={form.title}
              onChange={e => set("title", e.target.value)}
              style={{
                width:"100%", padding:"11px 14px", borderRadius:"10px",
                border:`1.5px solid ${form.title ? (isIncome ? "#86efac" : "#fca5a5") : "#e2e8f0"}`,
                fontSize:"14px", color:"#1e293b", background:"#fafafa",
                outline:"none", boxSizing:"border-box", transition:".2s",
              }}
            />
          </div>

          {/* AMOUNT */}
          <div style={{ marginBottom:"18px" }}>
            <label style={{ display:"block", fontSize:"12px", fontWeight:800, color:"#374151", textTransform:"uppercase", letterSpacing:".05em", marginBottom:"7px" }}>
              Amount (₹)
            </label>
            <input
              required type="number" min="0" step="0.01"
              placeholder="0.00"
              value={form.amount}
              onChange={e => set("amount", e.target.value)}
              style={{
                width:"100%", padding:"11px 14px", borderRadius:"10px",
                border:"1.5px solid #e2e8f0",
                fontSize:"16px", fontWeight:700, color:"#1e293b", background:"#fafafa",
                outline:"none", boxSizing:"border-box", transition:".2s",
              }}
            />
          </div>

          {/* DATE */}
          <div style={{ marginBottom:"28px" }}>
            <label style={{ display:"block", fontSize:"12px", fontWeight:800, color:"#374151", textTransform:"uppercase", letterSpacing:".05em", marginBottom:"7px" }}>
              Date
            </label>
            <input
              type="date" required
              value={form.date}
              onChange={e => set("date", e.target.value)}
              style={{
                width:"100%", padding:"11px 14px", borderRadius:"10px",
                border:"1.5px solid #e2e8f0",
                fontSize:"14px", color:"#1e293b", background:"#fafafa",
                outline:"none", boxSizing:"border-box",
              }}
            />
          </div>

          {/* SUBMIT */}
          <button
            type="submit" disabled={loading}
            style={{
              width:"100%", minHeight:"50px",
              background: isIncome
                ? "linear-gradient(135deg,#22c55e,#16a34a)"
                : "linear-gradient(135deg,#f97316,#ea580c)",
              color:"#fff", border:"none", borderRadius:"12px",
              fontSize:"15px", fontWeight:800,
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? .65 : 1,
              transition:".2s",
              boxShadow: isIncome
                ? "0 6px 20px rgba(34,197,94,.35)"
                : "0 6px 20px rgba(249,115,22,.35)",
              display:"flex", alignItems:"center", justifyContent:"center", gap:"8px",
            }}
          >
            {loading
              ? "Saving…"
              : `✓ Save ${isIncome ? "Income" : "Expense"}`
            }
          </button>

        </div>
      </form>
    </div>
  );
}
